import React from "react";
import middleware from "./middlewares/middleware";
import AllMarketer from "../component/sections/user/manage/marketer/AllMarketer";
import AddMarketer from "../component/sections/user/manage/marketer/AddMarketer";
import ViewMarketer from "../component/sections/user/manage/marketer/ViewMarketer";
import EditMarketer from "../component/sections/user/manage/marketer/EditMarketer";
import AllMarketerUserEditLog from "../component/sections/user/manage/marketer/AllMarketerUserEditLog";
import ViewMarketerUserEditLog from "../component/sections/user/manage/marketer/ViewMarketerUserEditLog";
import UserMarketerInfo from "../component/sections/user/marketer/UserMarketerInfo";
import AddUserByMarketer from "../component/sections/marketer/AddUserByMarketer";
import AddUserByMarketerOutSidePanel from "../component/sections/marketer/AddUserByMarketerOutSidePanel";
import AllUserRegisteredByMarketer from "../component/sections/marketer/AllUserRegisteredByMarketer";
import AddMarketerCheckout from "../component/sections/marketer/checkout/Add";
import AllMarketerCheckout from "../component/sections/marketer/checkout/All";
import ViewAskCheckout from "../component/sections/marketer/checkout/Info";
import ViewAllPayment from "../component/sections/marketer/ViewAllPayment";

const marketerRoutes = [
  {
    path: "/user/marketer/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllMarketer />,
        "AllMarketer"
      );
    },
    exact: true,
  },
  {
    path: "/user/marketer/add",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddMarketer />,
        "AddMarketer"
      );
    },
    exact: true,
  },
  {
    path: "/user/marketer/view/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewMarketer />,
        "ViewMarketer"
      );
    },
    exact: true,
  },
  {
    path: "/user/marketer/edit/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditMarketer />,
        "EditMarketer"
      );
    },
    exact: true,
  },
  {
    path: "/user/marketer/edit/all-log/:userID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllMarketerUserEditLog />,
        "AllMarketerUserEditLog"
      );
    },
    exact: true,
  },
  {
    path: "/user/marketer/edit/log/:logID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewMarketerUserEditLog />,
        "ViewMarketerUserEditLog"
      );
    },
    exact: true,
  },
  {
    path: "/user/marketer/info",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <UserMarketerInfo />,
        "UserMarketerInfo"
      );
    },
    exact: true,
  },
  {
    path: "/marketer/add-user",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddUserByMarketer />,
        "AddUserByMarketer"
      );
    },
    exact: true,
  },
  {
    path: "/marketer/add-user-outside-panel/:identityMarketer",
    render: () => {
      return middleware(
        ["isUserLogout"],
        <AddUserByMarketerOutSidePanel />,
        "AddUserByMarketerOutSidePanel"
      );
    },
    exact: true,
  },
  {
    path: "/marketer/all-user-registered",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllUserRegisteredByMarketer />,
        "AllUserRegisteredByMarketer"
      );
    },
    exact: true,
  },
  {
    path: "/marketer/all-ask-checkout",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllMarketerCheckout />,
        "AllMarketerCheckout"
      );
    },
    exact: true,
  },
  {
    path: "/marketer/add-ask-checkout",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddMarketerCheckout />,
        "AddMarketerCheckout"
      );
    },
    exact: true,
  },
  {
    path: "/marketer/view-ask-checkout/:askCheckoutID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewAskCheckout />,
        "ViewAskCheckout"
      );
    },
    exact: true,
  },
  {
    path: "/marketer/view-all-payment/:userID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ViewAllPayment />,
        "ViewAllPayment"
      );
    },
    exact: true,
  },
];

export default marketerRoutes;
